<template>
  <div
    class="label-searchable-select label-input-field label-input-field--glass"
    :class="[
      {
        'label-input-field--flex': flex,
        'label-input-field--error': hasError,
      },
      customClass,
    ]"
  >
    <span :id="labelId" class="label-input-field__label">
      {{ label }}<span v-if="required" class="label-input-field__required" aria-hidden="true">*</span>
    </span>
    <div class="label-searchable-select__control">
      <SimpleSearchableSelect
        :value="modelValue"
        :options="options"
        :placeholder="placeholder"
        :disabled="disabled"
        :option-value="optionValue"
        :option-label="optionLabel"
        @input="onInput"
        @update:modelValue="onInput"
        @change="onChange"
      />
    </div>
    <div v-if="$slots.default" class="label-input-field__messages">
      <slot />
    </div>
  </div>
</template>

<script>
import SimpleSearchableSelect from '@/components/SimpleSearchableSelect.vue';

export default {
  name: 'LabelSearchableSelect',
  components: {
    SimpleSearchableSelect,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    selectId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Select option...',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    optionLabel: {
      type: String,
      default: 'label',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['update:modelValue', 'input', 'change'],
  computed: {
    labelId() {
      return `${this.selectId}-label`;
    },
  },
  methods: {
    onInput(value) {
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style src="@/modules/consultant/styles/LabelInputField.css"></style>
<style src="@/components/styles/LabelSearchableSelect.css"></style>
